import { render, staticRenderFns } from "./AnswerQuestionModal.vue?vue&type=template&id=942a6ba4&scoped=true"
import script from "./AnswerQuestionModal.vue?vue&type=script&lang=js"
export * from "./AnswerQuestionModal.vue?vue&type=script&lang=js"
import style0 from "./AnswerQuestionModal.vue?vue&type=style&index=0&id=942a6ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942a6ba4",
  null
  
)

export default component.exports